import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Layout from 'shared/layouts/containers/Main'
import { Button, Form, Row } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import InputWrapper from 'shared/components/InputWrapper'
import resAddSite from './resolvers/resAddSite'
import useInit from './hooks/useInit'
import useFocusError from 'shared/hooks/useFocusError'
import prepareSubmitForm from 'shared/utils/prepareSubmitForm'
import submitForm from './utils/submitForm'
import HeaderCustomerSelect from 'containers/HeaderCustomerSelect'
import { roles } from 'consts'
import hasAnyRole from 'shared/utils/hasAnyRole'
import getBrandContent from 'utils/getBrandContent'
import Footer from 'shared/components/Footer'
import BackButton from 'shared/components/BackButton'

const submitRef = React.createRef<HTMLButtonElement>()

const AddSite: React.FunctionComponent = () => {
  const [showOverlay, setShowOverlay] = useState<boolean>(true)
  const [dataLoaded, setDataLoaded] = useState<boolean>(false)

  const [currentCustomer, setCurrentCustomer] = useState<{} | null>({})

  const { id } = useParams()

  const navigate = useNavigate()

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setFocus,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'all',
    resolver: resAddSite,
  })

  useInit({
    getValues,
    id,
    reset,
    setDataLoaded,
    setShowOverlay,
    currentCustomer,
  })

  useFocusError({
    errors,
    setFocus,
  })

  return (
    <Layout
      footerContent={<Footer />}
      brandContent={getBrandContent()}
      showOverlay={showOverlay}
      showCardHeader={true}
      showMinimizedBarButton={true}
      headerInsert={
        <BackButton url='/sites' text='All Sites' />
      }
      actionInsert={
        <Button
          disabled={!dataLoaded}
          type='submit'
          name='save'
          className='btn-round btn-primary'
          onClick={() => {
            if (submitRef.current != null) {
              submitRef.current.click()
            }
          }}
        >
          Save Site
        </Button>
      }
    >
      <Form
        onSubmit={handleSubmit((data) =>
          prepareSubmitForm({
            submitForm,
            navigate,
            data,
            setShowOverlay,
            setError,
            id,
            name: 'Site',
            successNav: '/sites',
          }),
        )}
        id='main-form'
      >
        <InputWrapper label='Name' name='name' errors={errors}>
          <Form.Control type='text' {...register('name')} />
        </InputWrapper>

        <Button
          type='submit'
          name='save'
          ref={submitRef}
          className='d-none'
        ></Button>
      </Form>
    </Layout>
  )
}

export default AddSite
